
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"28.428","height":"24.522","viewBox":"0 0 28.428 24.522"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Gruppe 948"}},[_c('g',{attrs:{"data-name":"Gruppe 771"}},[_c('g',{attrs:{"data-name":"Gruppe 745"}},[_c('path',{attrs:{"data-name":"Pfad 52","d":"M1 1.188l9.678 14.714v7.62h6.7v-7.62l10.05-14.714z","fill":"none","stroke":"#5e5149","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])])
          )
        }
      }
    